<template>
  <ul class="nav nav-tabs user-management-tabs">
    <li class="nav-item">
      <router-link class="nav-link" :class="{ active: $route.name === 'UserList' && !$route.query.archived }" :to="{ name: 'UserList' }">Active</router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" :class="{ active: $route.name === 'UserList' && !!$route.query.archived }" :to="{ name: 'UserList', query: { archived: 1 } }">Disabled</router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" :class="{ active: $route.name === 'RolePermissions' }" :to="{ name: 'RolePermissions' }">Role Permissions</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'UserManagementTabs',
};
</script>

<style scoped>
.user-management-tabs .nav-link { padding-left: 15px; padding-right: 15px; }
</style>
